var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33202 4.06166L5.48673 0.198431C5.42474 0.136194 5.34786 0.086236 5.26134 0.0519848C5.17483 0.0177337 5.08073 0 4.9855 0C4.89028 0 4.79618 0.0177337 4.70966 0.0519848C4.62314 0.086236 4.54626 0.136194 4.48428 0.198431L0.638982 4.06166C0.272004 4.43041 0.57626 5 1.14021 5H8.83189C9.39584 5 9.7001 4.43041 9.33202 4.06166Z",
    fill: "#95A3CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUp);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEwIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjMzMjAyIDQuMDYxNjZMNS40ODY3MyAwLjE5ODQzMUM1LjQyNDc0IDAuMTM2MTk0IDUuMzQ3ODYgMC4wODYyMzYgNS4yNjEzNCAwLjA1MTk4NDhDNS4xNzQ4MyAwLjAxNzczMzcgNS4wODA3MyAwIDQuOTg1NSAwQzQuODkwMjggMCA0Ljc5NjE4IDAuMDE3NzMzNyA0LjcwOTY2IDAuMDUxOTg0OEM0LjYyMzE0IDAuMDg2MjM2IDQuNTQ2MjYgMC4xMzYxOTQgNC40ODQyOCAwLjE5ODQzMUwwLjYzODk4MiA0LjA2MTY2QzAuMjcyMDA0IDQuNDMwNDEgMC41NzYyNiA1IDEuMTQwMjEgNUg4LjgzMTg5QzkuMzk1ODQgNSA5LjcwMDEgNC40MzA0MSA5LjMzMjAyIDQuMDYxNjZaIiBmaWxsPSIjOTVBM0NDIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };